import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { OidsRequestGet } from "../app/models/SupplierPortal"
import { digitalManagerApi } from "../services/api"

export function useOidsRequests() {
  const queryClient = useQueryClient()

  const { data: oidRequestList = [], isLoading: isLoadingOidRequests } = useQuery({
    queryKey: ["oidsRequests"],
    queryFn: () =>
      digitalManagerApi
        .get<OidsRequestGet[]>("/litePanelPro/objectIdsRequests")
        .then((r) => r.data),
  })

  const reloadOidRequests = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ["oidsRequests"] }),
    [queryClient]
  )

  return {
    oidRequestList,
    reloadOidRequests,
    isLoadingOidRequests,
  }
}
